/** @format */
import { Injectable } from '@angular/core';
import { CustomStudyDraft } from 'common-typescript/types';
import { isEmpty, map, pullAll } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class PlanDiffService {
    hasUnselectedCustomStudyDrafts(allCustomStudyDrafts: CustomStudyDraft[], selectedCustomStudyDrafts: CustomStudyDraft[]): boolean {
        const allCustomStudyDraftIds = map(allCustomStudyDrafts, 'id');
        const selectedCustomStudyDraftIds = map(selectedCustomStudyDrafts, 'id');
        const unselectedCustomStudyDrafts = pullAll(allCustomStudyDraftIds, selectedCustomStudyDraftIds);
        return !isEmpty(unselectedCustomStudyDrafts);
    }
}
